import React, { useState, useEffect, useRef } from "react";
import { NavLink, Link } from "react-router-dom";
import "../../styles/navbar.css";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem("theme");
    if (saved) return saved === "dark";
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });
  const navRef = useRef(null);

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      isDark ? "dark" : "light",
    );
    localStorage.setItem("theme", isDark ? "dark" : "light");
  }, [isDark]);

  useEffect(() => {
    function handleClick(e) {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY > 8);
    }
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function close() {
    setIsOpen(false);
  }

  return (
    <nav ref={navRef} className={scrolled ? "nav-scrolled" : ""}>
      <Link to="/" className="nav-logo" onClick={close}>
        Synergistic Intelligence
      </Link>

      <button
        className={`nav-toggle ${isOpen ? "is-open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle navigation"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li>
          <NavLink
            to="/about"
            onClick={close}
            className={({ isActive }) => (isActive ? "active-nav-link" : "")}
          >
            About
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/books"
            onClick={close}
            className={({ isActive }) => (isActive ? "active-nav-link" : "")}
          >
            Books
          </NavLink>
        </li>
        <li>
          <NavLink to="/assessment" className="nav-cta" onClick={close}>
            Take the Flow Identity Assessment
          </NavLink>
        </li>
        <li className="nav-divider" aria-hidden="true"></li>
        <li className="nav-theme-toggle-row">
          <span className="nav-theme-label">Appearance</span>
          <button
            className="nav-theme-toggle"
            data-active={isDark}
            onClick={() => setIsDark(!isDark)}
            aria-label="Toggle dark mode"
            aria-pressed={isDark}
          >
            <span className="nav-theme-toggle-knob">
              {isDark ? "🌙" : "☀️"}
            </span>
          </button>
        </li>
      </ul>
    </nav>
  );
}